import { useQuery } from '@tanstack/react-query'
import { getExpenseCategoriesService } from '@/services/expenseCategories'

export const expenseCategoriesQueryKey = (agendaId: string) => ['agendas', agendaId, 'expense-categories']

export const useExpenseCategories = (agendaId: string) =>
  useQuery({
    queryKey: expenseCategoriesQueryKey(agendaId),
    queryFn: () => getExpenseCategoriesService(agendaId),
  })
